// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__h6CDQ","rotator":"Loader_rotator__palA1","path":"Loader_path__KHTGI","dash":"Loader_dash__CfA9b","colors":"Loader_colors__OAFeT"};